'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JoinCta = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _PagePromotionCta = require('components/PagePromotion/PagePromotionCta');

var _promotions = require('constants/promotions');

var _multitrack = require('helpers/multitrack');

var _verify = require('helpers/verify');

var _localStorage = require('redux/saga/helpers/local-storage');

var _BaseCtaWithLink = require('./BaseCtaWithLink');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JoinCta = exports.JoinCta = function (_Component) {
  (0, _inherits3.default)(JoinCta, _Component);

  function JoinCta() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, JoinCta);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = JoinCta.__proto__ || (0, _getPrototypeOf2.default)(JoinCta)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      sessionPromotionAlias: null
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(JoinCta, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var sessionPromotionAlias = (0, _localStorage.readSessionStorage)(_PagePromotionCta.DEFAULT_PAGE_PROMOTION_SESSION_KEY, null, true);
      if (!(0, _verify.isBlank)(sessionPromotionAlias)) {
        this.setState({ sessionPromotionAlias: sessionPromotionAlias });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          schedule = _props.schedule,
          className = _props.className,
          props = (0, _objectWithoutProperties3.default)(_props, ['schedule', 'className']);
      var sessionPromotionAlias = this.state.sessionPromotionAlias;


      return _react2.default.createElement(
        _BaseCtaWithLink.BaseCtaWithLink,
        (0, _extends3.default)({
          className: (0, _classnames2.default)(className, 'bt--primary bt--outline')
        }, props, {
          to: '/pricing/' + (sessionPromotionAlias || _promotions.GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS),
          onClick: function onClick() {
            (0, _multitrack.ga)('Venue Details', 'Schedule Join Click', schedule.id);
          }
        }),
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'schedule.row.cta-join',
          defaultMessage: 'Join'
        })
      );
    }
  }]);
  return JoinCta;
}(_react.Component);

JoinCta.propTypes = {
  className: _propTypes2.default.string,
  schedule: _propTypes2.default.shape({
    id: _propTypes2.default.number.isRequired
  })
};